module.exports = "/fonts/opensansbolditalic.ttf";